<p-toast position="bottom-right"></p-toast>

<p-dialog
    [(visible)]="displayDialog"
    [style]="{ width: '600px' }"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    (onHide)="onDialogClosed()"
    [header]="selectedAnalisis ? 'Editar Análisis' : 'Nuevo Análisis'"
>
    <app-analisis-form 
        [model]="selectedAnalisis" 
        [sector]="sector"
        (onSave)="onSave($event)">
    </app-analisis-form>
</p-dialog>

<div>
    <div class="search-section">
        <div class="button-section">
            <span class="p-input-icon-left search-input">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="table?.filterGlobal($any($event.target).value, 'contains')"
                    placeholder="Buscar..." class="p-inputtext-sm">
            </span>
            <button mat-flat-button class="btn-new" (click)="openNew()">
                <mat-icon>add</mat-icon>
                Nuevo
            </button>
        </div>
    </div>

    <p-table #dt [value]="dataSource" [columns]="displayedColumns" [paginator]="true" [rows]="rows" [first]="first"
        [totalRecords]="totalRecords" [showCurrentPageReport]="true" [rowsPerPageOptions]="[5, 10, 20]"
        [scrollable]="true" [scrollHeight]="'280px'" styleClass="p-datatable-gridlines" [resizableColumns]="true"
        [autoLayout]="true" responsiveLayout="scroll" [loading]="loading"
        [globalFilterFields]="['iVariable','sDescripcion','numero_relacion','tipo','descripcion']" (onPage)="onPage($event)"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros">

        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of displayedColumns" [pSortableColumn]="col.field !== 'actions' ? col.field : null"
                    class="th-prime">
                    {{ col.header }}
                    <p-sortIcon *ngIf="col.field !== 'actions'" [field]="col.field"></p-sortIcon>
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td *ngFor="let col of displayedColumns" class="td-prime">
                    <ng-container [ngSwitch]="col.field">
                        <ng-container *ngSwitchCase="'actions'">
                            <div class="d-flex gap-2 justify-content-center">
                                <button pButton icon="pi pi-eye" class="p-button-rounded p-button-info p-button-text"
                                    (click)="openEdit(rowData)" pTooltip="Editar"></button>
                                <button pButton icon="pi pi-trash"
                                    class="p-button-rounded p-button-danger p-button-text" (click)="openDelete(rowData)"
                                    pTooltip="Eliminar"></button>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'iVariable'">
                            {{ rowData[col.field] }}
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{ rowData[col.field] }}
                        </ng-container>
                    </ng-container>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="6" class="text-center td-prime">
                    <span *ngIf="dataSource.length === 0 && !loading">No hay datos para mostrar</span>
                    <p-progressSpinner *ngIf="loading" styleClass="w-4rem h-4rem" strokeWidth="8"
                        fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>